module.exports = __webpack_public_path__ + "img/pexels-mídia-1454184.dc1a7c13.jpg";